import Matomo from '@components/Matomo';
import React from 'react';
import Usercentrics from './UserCentrics';
import GoogleTagManager from './GoogleTagManager';

const isProd = process.env.NODE_ENV === 'production';

function CustomScripts() {
  if (!isProd) return null;

  return (
    <>
      <GoogleTagManager />
      <Usercentrics />
      <Matomo />
    </>
  );
}

export default CustomScripts;
